import { getAxiosInstance } from '../../../np-rest/rest';
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchDeviceCasePreselections = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const countRes = await rest.post("/device-case-preselection/count", filterData);
            if (countRes.data.result?.data > 0) {
                let listRes = await rest.post("/device-case-preselection/list", filterData);
                if (listRes.data && !listRes.data.succeeded) {
                    snackActions.snackBar({
                        message: `${listRes && listRes.data && listRes.data.message ? listRes.data.message : "Cannot fetch device case preselections."}`,
                        options: {
                            variant: 'warning'
                        }
                    });
                    return { data: [], count: 0 };
                }
                if (listRes.data && listRes.data.succeeded) {
                    return { data: listRes.data.result.data, count: countRes.data.result.data }
                }
            } else if (!countRes.data || !countRes.data.result) {
                snackActions.snackBar({
                    message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot fetch device case preselections."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return { data: [], count: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch device case preselections."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: [], count: 0 }
        }
    }
}

export const fetchDeviceCasePreselection = id => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/device-case-preselection/load', id);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch device case preselection."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return {};
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch device case preselection."}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const fetchDeviceModels  = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/device-model/list", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch device models."}`,
                options: {
                    variant: 'warning'
                }
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch device models."}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
};

export const createDeviceCasePreselection = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/device-case-preselection/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created device case preselection.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create device case preselection."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const editDeviceCasePreselection = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/device-case-preselection/update', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated device case preselection.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit device case preselection."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const bulkDeleteDeviceCasePreselections = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/device-case-preselection/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully deleted device case preselections.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete device case preselections."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot delete device case preselections."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const resetDiagnoseCaseParams = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/device-case-preselection/reset-case-params', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully reset diagnose case params.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot reset diagnose case params."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const editDeviceCasePreselectionDiagnoseCaseParams = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/device-case-preselection/update-case-params', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated diagnose case params.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit diagnose case params."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

